import { useMemo, useState, useEffect } from 'react';
import { useDCAPageModelStore } from '@marriott/mi-store-utils';
import { useDCADynamicModel } from '../../hooks/useDCADynamicModel';
import { getMboxParamters } from '../../lib/helpers';
import { IUpdatedPageModel } from '../../types';

const getPageModelCopy = (pageModel: Record<string, unknown> = {}) => {
  try {
    // By doing will get exact copy of pageModel even nested parameretes will copied properly
    return JSON.parse(JSON.stringify(pageModel));
  } catch (e) {
    return pageModel;
  }
};

/**
 *
 * @param Component referece of a page
 * @param pageProps pageprps of page
 * @description this provider, will do single dca call, by taking the pagemodel
 * from pageProps, and then store the result in DCAPageModelStore
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DynamicDCAPageProvider = ({ Component, pageProps }: any) => {
  const pageModel = getPageModelCopy(pageProps?.model);
  useDCADynamicModel(getMboxParamters(pageModel), pageModel);
  return useMemo(() => <Component {...pageProps} />, []);
};

/**
 *
 * @param props - refers to component props
 * @param Component - refers to DCA component
 * @description this generic component provider will provide uxl response to the component i.e.,
 * once uxl call happens then this provider will return updated props to component, based on the mboxParameter...
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DynamicDCAComponentProvider = ({ props, Component }: any) => {
  const [dynamicProps, setDynamicProps] = useState(props);
  const [isPropsUpdated, setIsPropsUpdated] = useState(false);
  const updatedPageModel = useDCAPageModelStore(state => state.pageModel) as IUpdatedPageModel;

  useEffect(() => {
    setDynamicProps(props);
  }, [JSON.stringify(props)]);

  useEffect(() => {
    const mboxParameter = dynamicProps?.model?.mboxParameter;

    if (updatedPageModel?.mboxData?.length && !!mboxParameter && !isPropsUpdated) {
      const response = updatedPageModel?.mboxData?.find(
        item => item?.mboxName === mboxParameter && !!item?.dcaResponse
      )?.dcaResponse;

      if (response) {
        setIsPropsUpdated(true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setDynamicProps((prev: any) => ({ ...prev, model: { ...response }, ...response }));
      }
    }
  }, [updatedPageModel, dynamicProps]);

  return useMemo(() => <Component {...dynamicProps} />, [dynamicProps]);
};
